import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_SETTINGS_CONTEXT_SYMBOL = Symbol();
const useFormSettings = ()=>useImmutableContext(FORM_SETTINGS_CONTEXT_SYMBOL);
const useFormSettingsProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(FORM_SETTINGS_CONTEXT_SYMBOL, ...args);
};
export { useFormSettings, useFormSettingsProvider };
